document.addEventListener("DOMContentLoaded", function() {


  function initiateLogoVisibilityToggle() {
      const footerLogo = document.querySelector('.tl-footer-logo');
      const headerLogoWrapper = document.querySelector('.header__heading-logo-wrapper');
      const buildGridViewSwitch = document.querySelector('.mu-section__product-view-tabs-active-trigger');

      // If buildGridViewSwitch does not exist, warn but do not return
      if (!buildGridViewSwitch) {
          console.warn('buildGridViewSwitch does not exist!');
      }

      // Initialize the class for the footerLogo and headerLogoWrapper
      footerLogo && footerLogo.classList.add('tl-logo-transition-invisible');
      headerLogoWrapper && headerLogoWrapper.classList.add('tl-logo-transition-header-visible');
      // Initialize the class for buildGridViewSwitch if it exists
      buildGridViewSwitch && buildGridViewSwitch.classList.add('tl-logo-transition-invisible');

      const options = {
          root: null,
          rootMargin: '0px',
          threshold: 0.5
      };

      const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
              const isVisible = entry.isIntersecting;
              footerLogo.classList.toggle('tl-logo-transition-visible', isVisible);
              footerLogo.classList.toggle('tl-logo-transition-invisible', !isVisible);
              headerLogoWrapper.classList.toggle('tl-logo-transition-header-invisible', isVisible);
              headerLogoWrapper.classList.toggle('tl-logo-transition-header-visible', !isVisible);
              
              // Apply changes to buildGridViewSwitch if it exists
              if (buildGridViewSwitch) {
                  buildGridViewSwitch.classList.toggle('tl-logo-transition-invisible', isVisible);
                  buildGridViewSwitch.classList.toggle('tl-logo-transition-visible', !isVisible);
              }
          });
      }, options);

      // Observe the footerLogo if it exists
      footerLogo && observer.observe(footerLogo);
  }

  initiateLogoVisibilityToggle();
});
